import validationFunctions from '../../utils/validation';

const functions = validationFunctions;

export const validators = {
  Part_B_effective_date__c: functions.validateDate,
  Last_4_Digits_of_SSN__c: functions.validateSSN,
  validateInput: functions.validateInput,
};
